import { service, BASE_API } from '@/utils/request'

export default {
  /**
   * @description 获取列表数据
   * @param {number} pageIndex
   * @param {number} pageSize
   * @param {number} disciplineType	学科（1-妇科 2-产科 空-全部）
   * @param {string} phone 手机号
   * @param {string} realName 	姓名
   * @param {number} seasonType 赛季（必传 1-第三季 2-第四季...依次类推）
   * @param {number} selectedVoteNum 筛选票数（1-从高到底 2-从低到高 空-默认）
   * @returns
   */
  getCaseList: params => {
    return service({
      url: '/cloud/activity/admin/caseCollection/pages',
      method: 'get',
      params
    })
  },

  /**
   * @description 上下架
   * @param {string} id
   * @param {number} state 	1-上架 0-下架
   * @returns
   */
  changeState: params => {
    return service({
      url: '/cloud/activity/admin/caseCollection/changeState',
      method: 'post',
      params
    })
  },
  getDetails: params => {
    return service({
      url: '/cloud/activity/caseCollection202411/details',
      method: 'get',
      params
    })
  },

  /**
   * @description 保存
   * @param {string} content 富文本
   * @param {string} disciplineType 学科类型（1-妇科 2-产科）
   * @param {string} id 	数据id，新增不传，编辑需要传入
   * @param {string} metaData 文件数据（json格式）
   * @param {string} seasonType 赛季类型（1-第三季 2-第四季）...依次类推
   * @param {string} title 	标题
   * @param {string} userId	参赛作者
   * @returns
   */
  saveCase: data => {
    return service({
      url: '/cloud/activity/admin/caseCollection/save',
      method: 'post',
      data
    })
  },

  /**
   * @description 分享数据列表
   * @param {number} pageIndex
   * @param {number} pageSize
   * @param {string} endTime // 结束时间
   * @param {string} realName // 分享人
   * @param {number} seasonType // 赛季（必传 1-第三季 2-第四季...依次类推）
   * @param {string} startTime  // 开始时间
   * @param {string} worksId // 作品id
   * @returns
   */
  sharePages: params => {
    return service({
      url: '/cloud/activity/admin/caseCollection/data/sharePages',
      method: 'get',
      params
    })
  },
  /**
   * @description 分享数据导出
   * @param {string} endTime // 结束时间
   * @param {string} realName // 分享人
   * @param {string} seasonType // 赛季（必传 1-第三季 2-第四季...依次类推）
   * @param {string} startTime // 开始时间
   * @param {string} worksId // 作品id
   * @returns
   */
  exportShareExcel: params => {
    return service({
      url: '/cloud/activity/admin/caseCollection/exportShareExcel',
      method: 'get',
      params,
      responseType: 'blob'
    })
  },
  changeShareActivityState: params => {
    return service({
      url: '/cloud/activity/admin/caseCollection/changeShareActivityState',
      method: 'post',
      params
    })
  },
  shareActivityUserPages: params => {
    return service({
      url: '/cloud/activity/admin/caseCollection/shareActivityUserPages',
      method: 'get',
      params
    })
  },
  exportShareActivityUserExcel: params => {
    return service({
      url: '/cloud/activity/admin/caseCollection/exportShareActivityUserExcel',
      method: 'get',
      params,
      responseType: 'blob'
    })
  },
  getEvent: params => {
    return service({
      url: '/cloud/activity/admin/caseCollection/getEvent',
      method: 'get',
      params
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/operateManage/casequest.js